const slugify = (str, replacer = "-") => str.toString().toLowerCase().normalize("NFD").trim().replace(/&/g, "and").replace(/\s+/g, replacer).replace(/[^\w-]+/g, "").replace(new RegExp(`${replacer}${replacer}+`, "g"), "-");

export { slugify };
//# sourceMappingURL=slugify.js.map
//# sourceMappingURL=slugify.js.map